import { AnyObject } from 'antd/es/_util/type';
import { NoData } from './NoData';
import { SonarText } from './text';
import { Table } from 'antd';
import { TableProps } from 'antd/lib';

import { ColumnType, TableRef } from 'antd/es/table';
import React, { forwardRef, useMemo } from 'react';

const TableComponent = <T extends AnyObject>({ columns, locale, ...rest }: TableProps<T>, ref: React.Ref<TableRef>) => {
	const managedColumns = useMemo(() =>
		columns?.map((column) => ({
			...column,
			ellipsis: false,
			render: (value: unknown, object: T, index: number) => {
				const base = column.render ?
					column.render(value, object, index) :
					object[ (column as ColumnType<T>).dataIndex as string ];

				return column.ellipsis ?
					<SonarText
						ellipsis={ {
							tooltip: {
								children: base,
								placement: 'bottom',
								showArrow: true
							}
						} }>
						{ base }
					</SonarText> :
					base;
			}
		})), [ columns ]);

	return (
		<Table
			locale={ {
				emptyText: <NoData />,
				...locale
			} }
			{ ...rest }
			columns={ managedColumns }
			ref={ ref } />
	);
};

export const SonarTable = forwardRef(TableComponent);
